/**
 * Pure half of the trade-return surface. Kept free of React and next/navigation
 * so scripts/trade-return.test.mjs can import it under bare `node --test`;
 * TradeReturnSurface re-exports it so consumers have one import path.
 */

/**
 * Applies the clicked card's name to the registered surface's filter. Returns
 * undefined when no surface is registered, so callers keep today's behaviour.
 */
export function tradeReturnUrlForCard(
  cardName: string | undefined,
  surface: { filterKey?: string; baseUrl?: string }
): string | undefined {
  const { filterKey, baseUrl } = surface;
  if (!filterKey || !baseUrl) return undefined;
  if (!cardName) return baseUrl;

  const [path, search = ""] = baseUrl.split("?");
  const params = new URLSearchParams(search);
  params.set(filterKey, cardName);
  return `${path}?${params.toString()}`;
}
